export default __webpack_public_path__ + "static/media/04f_fold-24.1c5a6063.mp4";